import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-pane',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './pane.component.html',
})
export class PaneComponent {}
